import {History} from '../utils/NavigationHistoryUtils';
import {snackActions} from '../utils/SnackBarUtils';
import {setUserInfoToLocalStorage} from '../utils/index';

export const validateResponseData = (responseData) => {
    const {errors = []} = responseData;
    if (errors.length === 0) return responseData;

    const hasInvalidToken = errors.some((error) => {
        const code = error?.code ?? error?.errorCode;
        return code === 403000 || code === 403001;
    });

    if (hasInvalidToken) {
        try { localStorage.removeItem('token'); } catch (e) {}
        setUserInfoToLocalStorage('');
        History.navigate('/logout', {state: {navigateToLogin: true}});
    } else {
        const message = errors[0]?.message || errors[0]?.errorMessage || 'Unknown error';
        snackActions.error(message);
    }

    return responseData;
}
